module.exports = __webpack_public_path__ + "static/Mountain4-49c63cf7500a8c6ef15eed15de1c5d35.png";